import {BookPayload, GeneralAction} from '../../../@types/actions';
import {BOOK_EVENT} from '../../../constants/ExtraConstants';

export const BookEventAction = (data: BookPayload): GeneralAction<BookPayload> => ({
    type: BOOK_EVENT,
    payload: data
});
